import React from 'react';
import { routeMap } from 'router';
import { useQuery } from 'react-query';
import { Link } from 'redux-little-router';

import BlueBlock from 'modules/Profile/components/PersonalData/components/BlueBlock';
import getContactInfo from 'modules/Profile/services/API/getPersonalData';
import RelativeLoading from '../../../../../../components/Loading/RelativeLoading';

import { apiResponseWrapper } from 'utils/apiResponseWrapper';
import { injectParamsInRoute } from 'utils';

import styles from '../TaxExemptionsList/TaxExemptionsList.module.scss';

export default function BiggestStatus() {
  const { data, isLoading } = useQuery('getContactInfo', async () => {
    const res = await getContactInfo();
    return apiResponseWrapper(res);
  });

  const biggestTaxInspection = data?.biggestTaxInspection;
  const link = injectParamsInRoute(routeMap.contactsDetail, { id: biggestTaxInspection?.taxCode });

  if (!biggestTaxInspection) return null;
  if (isLoading) return <RelativeLoading />;

  return (
    <div className={styles.TaxExemptionsList}>
      <h2>Статус</h2>
      <BlueBlock>
        <div>Крупнейший налогоплательщик</div>
        <p>
          Ваш налоговый орган - <Link href={link}>{biggestTaxInspection.taxName}</Link>
        </p>
        <p>
          Налоговые декларации (расчеты), обращения и иные документы необходимо представлять в
          указанный налоговый орган
        </p>
        <Link href={routeMap.helpBiggest}>Подробнее</Link>
      </BlueBlock>
    </div>
  );
}
